import React, { useEffect, useState } from "react";
import axios from "axios";
import CommonConfigTable from "./CommonConfigTable";
import { useSelector } from "react-redux";
import AwsAccountsTable from "./AwsAccountsTable";
import AwsBillEmailTable from "./AwsBillEmailTable";
import UnauthorizedPage from "../../UnauthorizedPage";

export default function CommonConfig() {
  const [oem, setOem] = useState("");
  const [region, setRegion] = useState("");
  const [product, setProduct] = useState("");
  const [environment, setEnvironment] = useState("");
  const [awsAccounts, setAwsAccounts] = useState("");
  const [awsBillTo, setAwsBillTo] = useState([]);
  const [awsBillCc, setAwsBillCc] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  let accessToken = useSelector((state) => state.accessToken.value);
  const apiUrl = process.env.REACT_APP_API_URL;

  function convertToObjectsArray(data) {
    return Object.keys(data).map((key) => ({
      name: key,
      description: data[key],
    }));
  }

  const getDetails = async () => {
    setLoading(true);
    const query = `
    query GetDetails($id: String!) {
      getDetails(id: $id) {
        id
        oem
        region
        environment
        product
        }
        }
        `;

    const variables = {
      id: "1",
    };
    const response = await axios.post(
      apiUrl,
      { query, variables },
      {
        headers: {
          Authorization: accessToken,
        },
      }
    );
    const queryAws = `
   query MyQuery {
  getAWSAccounts {
    AccountName
    AccountNo
    Status
    id
  }
}
        `;
    await axios
      .post(
        apiUrl,
        { query: queryAws },
        {
          headers: {
            Authorization: accessToken,
          },
        }
      )
      .then((response) => {
        if (response.data.data.getAWSAccounts) {
          setAwsAccounts(response.data.data.getAWSAccounts);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    const queryAwsBill = `
      query GetAwsBillEmails {
        getAwsBillEmails {
          to {
            name
            email
          }
          cc {
            name
            email
          }
        }
      }
    `;
    await axios
      .post(
        apiUrl,
        { query: queryAwsBill },
        { headers: { Authorization: accessToken } }
      )
      .then((response) => {
        if (response.data.data && response.data.data.getAwsBillEmails) {
          setAwsBillTo(response.data.data.getAwsBillEmails.to || []);
          setAwsBillCc(response.data.data.getAwsBillEmails.cc || []);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    if (response.data.data.getDetails) {
      const configurationDetails = JSON.parse(response.request.response);
      setOem(
        convertToObjectsArray(
          JSON.parse(configurationDetails.data.getDetails.oem)
        )
      );
      setRegion(
        convertToObjectsArray(
          JSON.parse(configurationDetails.data.getDetails.region)
        )
      );
      setProduct(
        convertToObjectsArray(
          JSON.parse(configurationDetails.data.getDetails.product)
        )
      );
      setEnvironment(
        convertToObjectsArray(
          JSON.parse(configurationDetails.data.getDetails.environment)
        )
      );
    }
    if (
      response.data.errors &&
      response.data.errors[0].errorType == "Unauthorized"
    )
      setError("Unauthorized");

    setLoading(false);
  };

  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    getDetails();
  }, [refresh]);

  if (error == "Unauthorized") {
    return <UnauthorizedPage />;
  }
  return (
    <div className="grid grid-cols-2 gap-4 shadow-md rounded-lg p-4 bg-gradient-to-b from-[#003366]/5 to-white ">
      <CommonConfigTable
        data={oem}
        name={"OEM"}
        refresh={refresh}
        setRefresh={setRefresh}
        loading={loading}
      />
      <CommonConfigTable
        data={product}
        name={"Product"}
        refresh={refresh}
        setRefresh={setRefresh}
        loading={loading}
      />
      <CommonConfigTable
        data={environment}
        name={"Environment"}
        refresh={refresh}
        setRefresh={setRefresh}
        loading={loading}
      />
      <CommonConfigTable
        data={region}
        name={"Region"}
        refresh={refresh}
        setRefresh={setRefresh}
        loading={loading}
      />
      <AwsAccountsTable
        data={awsAccounts}
        name={"AWS Account"}
        refresh={refresh}
        setRefresh={setRefresh}
        loading={loading}
      />
      <AwsBillEmailTable
        title={"Aws Bill Reminder Email"}
        toList={awsBillTo}
        ccList={awsBillCc}
        refresh={refresh}
        setRefresh={setRefresh}
        loading={loading}
      />
    </div>
  );
}
